import React from 'react';
import PropTypes from 'prop-types';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import Loading from 'Components/Loading';
import loadable from '@loadable/component';

const BestOfYear = loadable(() => pMinDelay(import('./BestOfYear'), 300), {
  fallback: <Loading />
});

const AsyncBestOfYear = props => {
  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <BestOfYear { ...props } helmet={ pageConfig.helmet } />
    </ApplicationLayout>
  );
};

AsyncBestOfYear.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncBestOfYear;
